import React from "react";
import { StatusBadge } from "../../../../shared/components/badges/StatusBadge";
import { ExpandedAccordion } from "../../../../shared/components/ui/ExpandedAccordion";

const DistricExpandedRow = ({ item }) => {
  const sections = [
    {
      id: "basic",
      title: "Basic Info",
      fields: [
        { label: "District Name", value: item.name || "—" },
        { label: "State", value: item.state || "—" },
        // { label: "District Code", value: item.districtCode || "—" },
        // { label: "Description", value: item.description || "—", isLong: true },
        { label: "Status", value: item.status ? <StatusBadge status={item.status} /> : "—" },
      ],
    },
    {
      id: "contact",
      title: "Contact Info",
      fields: [
        { label: "Contact Person", value: item.contactPerson || "—" },
        { label: "Phone", value: item.phone || "—" },
        { label: "Email", value: item.email || "—" },
        { label: "Office Address", value: item.officeAddress || "—", isLong: true },
      ],
    },
  ];

  return <ExpandedAccordion sections={sections} />;
};

export default DistricExpandedRow;
